import { getLoaders } from "common/components/WithLoader/LoadingSelectors";
import { RootState } from "RootReducer";

export const selectAnyIsLoading = <LoaderType extends string = string>(state: RootState) => {
  const loaders = getLoaders(state);
  return (...loaderIds: LoaderType[]): boolean => loaderIds.some((loaderId) => loaders.includes(loaderId));
};
